<!--
 * @Author: cmchiu
 * @Date: 2022-04-27 09:32:30
 * @LastEditTime: 2023-06-28 17:41:05
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\Breadcrumb\breadcrumb.vue
 * 
-->
<template>
    <h1 class="breadcrumb">
        <el-breadcrumb separator="»">
            <transition-group name="breadcrumb">
                <el-breadcrumb-item v-for="(item, index) in levelLs" :key="item.path">
                    <span v-if="item.redirect === 'noRedirect' || index == levelLs.length - 1" class="no-redirect">{{
                        ['PostNews', 'PostDept'].includes(item.name)
                            ? $store.getters.pnTitle || item.meta.title
                            : item.meta.title
                    }}</span>
                    <a
                        v-else
                        @click.prevent="handleLink(item)"
                        @keyup.enter="handleLink(item)"
                        :title="item.meta.title"
                        tabindex="0"
                    >
                        <img v-if="item.meta.title === '首頁'" :src="`${baseUrl}assets/images/home.png`" alt="" />
                        <span v-text="item.meta.title"></span>
                    </a>
                </el-breadcrumb-item>
            </transition-group>
        </el-breadcrumb>
    </h1>
</template>

<script>
import XEUtils from 'xe-utils'
import { compile } from 'path-to-regexp'

export default {
    name: 'breadcrumb',

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            levelLs: [],
        }
    },

    watch: {
        $route() {
            this.getBreadcrumb()
        },
    },

    created: function () {
        this.getBreadcrumb()
    },

    methods: {
        getBreadcrumb() {
            // only show routes with meta.title
            let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
            const first = matched[0]

            XEUtils.lastArrayEach(matched, item => {
                if (item.parent && item.parent.meta.title === 'XXXX風雲榜') {
                    item.parent.meta.title = item.meta.title
                }
            })

            if (!this.isDashboard(first)) {
                matched = [{ path: '/home', meta: { title: '首頁' } }].concat(matched)
            }

            this.levelLs = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        },
        isDashboard(route) {
            const name = route && route.name
            if (!name) {
                return false
            }
            return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase()
        },
        handleLink(item) {
            const { redirect, path } = item
            if (redirect) {
                this.$store.dispatch('app/cachePNTitle', '')
                this.$router.push(redirect)
                return
            }
            this.$router.push(this.pathCompile(path))
        },
        pathCompile(path) {
            const { params } = this.$route
            var toPath = compile(path)
            return toPath(params)
        },
    },
}
</script>

<style scoped lang="scss">
.breadcrumb {
    margin-bottom: 16px;

    img {
        width: 14px;
    }

    a {
        color: #2d9698;
    }

    ::v-deep .el-breadcrumb__separator {
        color: unset;
        margin: 0 0.5rem;
    }
}
</style>
